import Component from "@glimmer/component";
import ENV from "glesys-controlpanel/config/environment";
import { action } from "@ember/object";
import { dropTask, keepLatestTask } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class extends Component {
  @service ajax;
  @service notification;
  @service intl;
  @service modal;
  @service abilities;
  @service store;

  get server() {
    return this.args.params.server;
  }

  get project() {
    return this.args.params.project;
  }

  @tracked backupSchedules = [];

  get noSchedulesSelected() {
    return !this.server.backup.enabled && !this.backupSchedules.some((s) => s.enabled);
  }

  @action
  updateSchedule(backupSchedules) {
    this.backupSchedules = backupSchedules;
    this.getKVMServerBackupCostTask.perform();
  }

  getKVMServerBackupCostTask = keepLatestTask(async () => {
    if (this.abilities.cannot("access pricing for organization", this.project.organization)) {
      return;
    }
    let url = `${ENV.apiBaseUri}/server/estimatedcost`;

    let numberOfBackupImagesFromSchedules = this.backupSchedules
      .filter((schedule) => schedule.enabled)
      .reduce((totalPrice, schedule) => totalPrice + schedule.numberofimagestokeep, 0);

    let data = {
      projectkey: this.project?.id,
      serverid: this.server.id,
      cpucores: this.server.cpucores,
      disksize: this.server.disksize,
      memorysize: this.server.memorysize,
      numberofbackupimagestokeep: numberOfBackupImagesFromSchedules,
    };

    try {
      let response = await this.ajax.post(url, { data });
      return {
        price: response.billing.price,
        total: response.billing.total,
      };
    } catch {
      return {
        price: null,
      };
    }
  });

  configureBackupTask = dropTask(async () => {
    let { server } = this;

    server.backupschedules = this.backupSchedules
      .filter((schedule) => schedule.enabled)
      .map(({ frequency, numberofimagestokeep }) => ({ frequency, numberofimagestokeep }));

    await this.store.request(saveRecord(server));

    this.modal.close();
    this.notification.add(
      "success",
      this.intl.t("server.details.backup.updated.title"),
      this.intl.t("server.details.backup.updated.content"),
    );
  });
}
